import {Component, OnDestroy, OnInit} from '@angular/core';
import {ROUTES} from './sidebar-routes.config';
import * as _ from 'lodash';
import {Principal} from '../auth/principal.service';
import {JhiEventManager} from 'ng-jhipster';
import {environment} from "../../../environments/environment";
import {NotificheService} from "../../notifiche/notifiche.service";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {MessageService} from "../../MessageService";
import { Subscription } from 'rxjs/Subscription';

declare var $: any;

@Component({
  // moduleId: module.id,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})

export class SidebarComponent implements OnInit, OnDestroy {
  public menuItems: any[];
  notifiche: any[];
  account: any;
  logoRight=environment.logoRight;
  logoLeft=environment.logoLeft;
  logo=environment.logoLogin;

  subscription: Subscription;

  constructor(
    private principal: Principal,
    private eventManager: JhiEventManager,
    private notificheService: NotificheService,
    private messageService: MessageService
  ) {
  }

  ngOnInit() {
    this.getAccount();
    this.registerAuthenticationSuccess();
    this.reloadNotification();
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  private reloadNotification() {
    this.notificheService.getNotification().subscribe((res) => {
      this.notifiche = res;
      this.notifiche.forEach((notify) => {
        if ((notify.fkType == 0 && notify.read == true) || (notify.vote == true)) {
          this.notifiche.pop();
        }
      });
      this.setbadge();
    });
  }

  private getAccount() {
    this.principal.identity().then((account) => {
      this.account = account;
      this.loadMenuItems();
    });
  }

  registerAuthenticationSuccess() {
    this.eventManager.subscribe('authenticationSuccess', (message) => {
      this.principal.identity(true).then((account) => {
        this.account = account;
        this.loadMenuItems();
      });
    });
    this.subscription = this.messageService.getMessage().subscribe(eventName => {
      if(eventName.text == "notificationChange"){
        this.reloadNotification()
      }
    });

  }

  setbadge(){
    this.menuItems.forEach( (menuItem)=>{
      if(menuItem.title == 'Notifiche') {
        menuItem.badge = this.notifiche.length;
      }
    })
  }


  /*private loadMenuItems() {
    $.getScript('./assets/js/app-sidebar.js');
    // console.log(this.account.comiteeType);
    const myItems = _.filter(ROUTES, (elem) => {
      if (_.intersection(Array(this.account.comiteeType), elem.committee).length){
        return _.intersection(this.account.permission, elem.permission).length;
      }else{
        return 0;
      }
    });

    if (!this.account.loggedAs || !this.account.loggedAs.permissions) {
      this.menuItems = myItems;
    } else {
      this.menuItems = _.filter(myItems, (elem: any) => {
        if (_.intersection(Array(this.account.comiteeType), elem.committee).length) {
          return _.intersection(this.account.loggedAs.permissions, elem.permission).length;
        } else {
          return 0;
        }

      });
    }
  }*/

  private loadMenuItems() {
    $.getScript('./assets/js/app-sidebar.js');

    const effectivePerms =
      (!this.account.loggedAs || !this.account.loggedAs.permissions)
        ? this.account.permission
        : this.account.loggedAs.permissions;

    const hasCommittee = (item: any) =>
      _.intersection([this.account.comiteeType], item.committee || []).length > 0;

    const hasPermission = (item: any) =>
      _.intersection(effectivePerms || [], item.permission || []).length > 0;

    const isVisible = (item: any) => hasCommittee(item) && hasPermission(item);

    const filterItems = (items: any[]): any[] => {
      return (items || [])
        .map((item) => {
          const cloned = { ...item };

          if (Array.isArray(cloned.submenu) && cloned.submenu.length) {
            cloned.submenu = filterItems(cloned.submenu);
          }

          return cloned;
        })
        .filter((item) => {
          // 1️⃣ se NON è visibile → fuori
          if (!isVisible(item)) return false;

          // 2️⃣ se è un "has-sub" ma il submenu è vuoto → fuori
          if (
            item.class === 'has-sub' &&
            Array.isArray(item.submenu) &&
            item.submenu.length === 0
          ) {
            return false;
          }

          // 3️⃣ tutti gli altri casi → ok
          return true;
        });
    };

    this.menuItems = filterItems(ROUTES);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts